var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning2Component = function SvgWarning2Component(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14c0-7.677-6.323-14-14-14C6.266 0 0 6.323 0 14c0 7.734 6.266 14 14 14 7.677 0 14-6.266 14-14Zm-14 2.823c1.411 0 2.597 1.185 2.597 2.596A2.59 2.59 0 0 1 14 22.016c-1.468 0-2.597-1.129-2.597-2.597A2.59 2.59 0 0 1 14 16.823Zm-2.484-9.315c-.056-.395.282-.734.678-.734h3.556c.395 0 .734.339.677.734l-.395 7.677c-.056.396-.338.621-.677.621h-2.766c-.339 0-.621-.225-.678-.62l-.395-7.678Z",
    fill: "current"
  })));
};
export default SvgWarning2Component;